import { apiClient } from '../apiClient';

export type Role = 'superadmin' | 'admin' | 'researcher' | 'viewer';

export interface AdminUser {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  role: Role;
  emailVerified: boolean;
}

// List all users (super admin only); optional search by name/email.
export async function getUsers(search?: string): Promise<AdminUser[]> {
  const response = await apiClient.get('/api/admin/users', {
    params: search ? { search } : {},
  });
  return response.data.users;
}

// Update a user's global role (super admin only).
export async function updateUserRole(id: string, role: Role): Promise<void> {
  await apiClient.patch(`/api/admin/users/${id}/role`, { role });
}
